var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6.61 5.1A1.9 1.9 0 0 1 4.71 7c-1.05 0-1.9-.86-1.9-1.92s.85-1.92 1.9-1.92c1.05 0 1.9.86 1.9 1.92zm.02 3.45H2.79v12.28h3.84zm6.12 0h-3.8v12.28h3.8v-6.45c0-3.58 4.63-3.88 4.63 0v6.45h3.83v-7.78c0-6.05-6.85-5.83-8.46-2.85z"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7ad9ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/LinkedIn.vue
// module id = DwTg
// module chunks = 0 1 3 4 5